query GetSubAccountsForAccount(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
  $orderBy: [OrderByItemInput!]
) {
  subAccountsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
    orderBy: $orderBy
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        customerId
        insertedAt
        updatedAt
        deactivatedAt
        name
        lrnAccess
        smsAccess
        mmsAccess
        maxSubAccounts
        parentAccount {
          id
        }
      }
    }
  }
}
